<template>
	<div
		:class="[
			'relative bg-default shadow-lg rounded-xl max-w-fit mx-auto min-w-56 h-20 border-1 border-gray-100 text-2xl text-highlighted font-semibold flex items-center justify-center',
			{ 'border-b-primary border-b-8 rounded-xl bg-gradient-to-br from-primary/15 to-white': index > 2 }
		]"
	>
		<div>
			<span>
				{{ option.speed }}
			</span>
			<span class="text-lg">
				{{ option.unit }}
			</span>
		</div>
	</div>
</template>

<script setup lang="ts">
defineProps({
	option: {
		type: Object as PropType<{ speed: number
			unit: string }>,
		required: true
	},
	index: {
		type: Number,
		required: true
	}
})
</script>
